// Training item labels and colors for UI display

import { TRAINING_ITEM_TYPE, TRAINING_ITEM_STATUS } from "@academy-context/shared/domain/types/training-items";
import type { LucideIcon } from "lucide-react";
import { Building2, GraduationCap, Music, Presentation } from "lucide-react";

/**
 * Human-readable labels for training item types
 */
export const TRAINING_ITEM_TYPE_LABELS: Record<TRAINING_ITEM_TYPE, string> = {
  [TRAINING_ITEM_TYPE.ONE_ON_ONE_LESSONS]: "Coaching individuel",
  [TRAINING_ITEM_TYPE.PROVIDER_BATCH]: "Masterclass partenaire",
  [TRAINING_ITEM_TYPE.TEACHER_BATCH]: "Masterclass professeur",
  [TRAINING_ITEM_TYPE.EXTERNAL_PROVIDER_BATCH]: "Masterclass externe",
};

/**
 * Icons for training item types
 */
export const TRAINING_ITEM_TYPE_ICONS: Record<TRAINING_ITEM_TYPE, LucideIcon> = {
  [TRAINING_ITEM_TYPE.ONE_ON_ONE_LESSONS]: Music,
  [TRAINING_ITEM_TYPE.PROVIDER_BATCH]: Building2,
  [TRAINING_ITEM_TYPE.TEACHER_BATCH]: GraduationCap,
  [TRAINING_ITEM_TYPE.EXTERNAL_PROVIDER_BATCH]: Presentation,
};

/**
 * Human-readable labels for training item statuses
 */
export const TRAINING_ITEM_STATUS_LABELS: Record<TRAINING_ITEM_STATUS, string> = {
  [TRAINING_ITEM_STATUS.SCHEDULED]: "Planifié",
  [TRAINING_ITEM_STATUS.RUNNING]: "En cours",
  [TRAINING_ITEM_STATUS.COMPLETED]: "Terminé",
  [TRAINING_ITEM_STATUS.CANCELLED]: "Annulé",
  [TRAINING_ITEM_STATUS.REJECTED]: "Refusé",
  [TRAINING_ITEM_STATUS.PENDING_ENROLLMENT]: "Pré-inscrit",
};

/**
 * Badge color variants for training item statuses
 * Maps to shadcn/ui Badge component variants
 */
export const TRAINING_ITEM_STATUS_COLORS: Record<TRAINING_ITEM_STATUS, "default" | "secondary" | "success" | "outline" | "destructive"> = {
  [TRAINING_ITEM_STATUS.SCHEDULED]: "secondary",
  [TRAINING_ITEM_STATUS.RUNNING]: "default",
  [TRAINING_ITEM_STATUS.COMPLETED]: "success",
  [TRAINING_ITEM_STATUS.CANCELLED]: "destructive",
  [TRAINING_ITEM_STATUS.REJECTED]: "destructive",
  [TRAINING_ITEM_STATUS.PENDING_ENROLLMENT]: "secondary",
};
